import { BlockedProviders, OrderStatus, PaymentMethodTypeId, SurvicateTaskStatus } from "../enums/survicate.enum";
import { SurvicateService } from "../services/survicate.service";
import { checkForOverlays } from "../utilities/utilities";

export const depositConditionFn = function (taskName: string): Promise<boolean> { 
    return new Promise((resolve, reject) => {
        const survicateService: SurvicateService = SurvicateService.getInstance();
        const blockedProvidersArray: (string | BlockedProviders)[] = Object.values(BlockedProviders).filter(value => typeof value === 'number');

        const isExecutionEnabled = typeof survicateService.getTaskEnabledMap().get(taskName) !== 'undefined' ? survicateService.getTaskEnabledMap().get(taskName) : SurvicateTaskStatus.Enabled;

            if(survicateService.getUserId() === '0') { //anonymous user
                survicateService.setTaskEnabledMap(taskName, SurvicateTaskStatus.Enabled);
                resolve(false);
            } else {
                if(isExecutionEnabled === SurvicateTaskStatus.Enabled) {
                    if (checkForOverlays() === true) {
                        survicateService.setTaskEnabledMap(taskName, SurvicateTaskStatus.Disabled); //disable task until next session
                        resolve(false);
                    } else {
                        survicateService.getPaymentOrders(PaymentMethodTypeId.Deposit).then((result) => {
                            const filteredOrders = result.filter((order: any) =>
                                order['isWithdrawal'] === false &&
                                (order['statusId'] === OrderStatus.Done || order['statusId'] === OrderStatus.DoneWithErrors) &&
                                order['isDoneByBackOffice'] === false &&
                                order['isDoneByService'] === false &&
                                blockedProvidersArray.includes(order['providerId']) === false
                            );
            
                            if(filteredOrders.length > 0) {
                                survicateService.setTaskEnabledMap(taskName, SurvicateTaskStatus.Disabled);
                                resolve(true);
                            } else {
                                survicateService.setTaskEnabledMap(taskName, SurvicateTaskStatus.Disabled);
                                resolve(false);
                            }
                        });
                    }
                } else {
                    resolve(false);
                }
            }           
    });
}